import styled, {css} from 'styled-components'

export const StyledRadioInputWrapper = styled.label(
    ({theme: {spacing, palette, typography}}) => css`
        display: flex;
        gap: ${spacing * 2}px;
        cursor: pointer;

        & > p {
            ${typography.textSm};
            color: ${palette.neutral['950']};
            overflow: hidden;
            text-overflow: ellipsis;
        }
    `
)
